import type { BoundElementDefinition } from '../types';
import type { BindingId } from '../../runtime/dataServices/types';
import { createDefaultImageSettings, type ImageSettings } from './contracts';
import { createRuntimeBindingInsertionPresetsForKind } from '../runtimeBindingPresetUtils';
import { createBoundElementDefinition } from '../types';

export type ImageDefinition = BoundElementDefinition<'image', ImageSettings>;

export function createBlankImageDefinition(): ImageDefinition {
    return createBoundElementDefinition('image', {
        ...createDefaultImageSettings(),
        binding: null,
    });
}

function createImageDefinitionForBindingId(bindingId: BindingId, alt: string): ImageDefinition {
    return createBoundElementDefinition('image', {
        ...createDefaultImageSettings(),
        binding: { bindingId },
        alt,
    });
}

export function createRuntimeImageInsertionPresets() {
    return createRuntimeBindingInsertionPresetsForKind({
        valueKind: 'image',
        keyPrefix: 'image_binding',
        createDefinitionForBindingId: (bindingId, descriptor) =>
            createImageDefinitionForBindingId(bindingId, descriptor.link.label),
    });
}
